import * as React from "react";
import {Footer} from "./Footer";
import '../styles/Dialog.css';
import {DialogContainer} from "./DialogContainer";
import {Header} from "./Header";
import {CSSProperties} from "react";
import {ReactUtilities} from "../../../utilities/react/ReactUtilities";

let ReactDOM:any=require('react-dom');
export class Dialog extends React.Component<DialogProps, DialogState> {
    static defaultProps: Partial<DialogProps> = {
        IsDynamic:false,
        EnableCancel:true,
        IsDestroyed:false,
        ShowHeader:true,
        CloseOnClickingOutside:false,
        ShowFooter:true
    };
    static Footer=Footer;
    static Header:Header;
    Destroyed:boolean;
    constructor(props: DialogProps, context?: any) {
        super(props, context);
        this.state = {};
    }





    public render() {
        if(this.Destroyed)
            return null;
        let content=<DialogContainer {...this.props}/>;
        if(this.props.IsDynamic)
            return content;


        return ReactDOM.createPortal(content,document.body);
    }

    public static Show<T=any>(Dialog:any):Promise<T>
    {
        return new Promise<T>(resolve=>{

            let div=document.createElement('div');
            document.body.style.overflow='hidden';
            document.body.appendChild(div);
            let ref:any;
            let resultSent:boolean=false;
            let clonedDialog=React.cloneElement(Dialog as any,{IsOpen:true,IsDynamic:true,
                ref:node=>{
                    if(node==null)
                    {
                        ref=null;
                        return;
                    }
                    if(typeof node.OnDispose=="undefined")
                         console.warn('Dialog does not implement interface DynamicDialog, it can not be used dynamically');

                    ref=node;
                    ref.OnDispose=(result)=>{


                        ReactUtilities.ExecuteMethodPropIfDefined(Dialog.props.OnClose);
                        if((window as any).RNOpenDialogsCount==0)
                            document.body.style.overflow='';
                        document.body.removeChild(div);
                        if(!resultSent)
                        {
                            resolve(null);
                            resultSent=true;
                        }
                        ref=null;
                    };

                    ref._sendResult=(result)=>{
                        if(!resultSent)
                        {
                            resolve(result);
                            resultSent=true;
                        }

                    };

                }
            });
            ReactDOM.render(clonedDialog,div);
        });

    }



}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------


export interface DialogProps {
    IsOpen?:boolean;
    Icon?:JSX.Element;
    Title?:any;
    OnApply?:()=>void;
    OnClose?:()=>void;
    AfterOnClose?:()=>void;
    OnCancel?:()=>void;
    CancelTitle?:string;
    CancelIcon?:any;
    ApplyTitle?:string;
    ApplyIcon?:any;
    IsDynamic?:boolean;
    Styles?:CSSProperties;
    EnableCancel?:boolean;
    EnableApply?:boolean;
    IsBusy?:boolean;
    FooterArea?:JSX.Element;
    ContentStyles?:CSSProperties;
    class?:string;
    IsDestroyed?:boolean;
    ShowHeader?:boolean;
    ShowFooter?:boolean;
    CloseOnClickingOutside?:boolean;

}

interface DialogState {

}

//#endregion "My Region"